// This script runs immediately to fix any localhost URLs
(function() {
  // Check if URL fixes are already being handled by main.js
  if (window.__urlFixesRunning || window.__urlFixesApplied) {
    console.log('URL fixes already being handled by main.js, skipping redundant fixes');
    return;
  }

  console.log('Running URL fix script from fixurls.js...');
  
  // Set global flag to indicate we're handling URL fixes
  window.__urlFixesRunning = true;
  
  // Flag to prevent multiple executions
  let fixesApplied = 0;
  const MAX_FIXES = 1; // Reduce to just one attempt

  // Function to detect if there are still localhost references
  const hasLocalhostReferences = () => {
    return document.documentElement.innerHTML.includes('localhost');
  };

  // Check and mark completion
  const checkAndMarkComplete = () => {
    if (!hasLocalhostReferences()) {
      window.__urlFixesApplied = true;
      console.log('All URL fixes completed successfully');
    }
  };

  // Replace all localhost URLs in the HTML, with safer approach
  function fixHtmlContent() {
    // Check if there are localhost URLs to fix
    if (hasLocalhostReferences()) {
      console.log('Found localhost URLs in HTML, fixing...');
      
      // Fix all image sources with localhost
      document.querySelectorAll('img[src*="localhost"]').forEach(img => {
        try {
          const url = new URL(img.src);
          img.src = url.pathname;
        } catch (e) {
          console.error('Error fixing image src:', e);
        }
      });

      // Fix all data-src attributes for lazy loading
      document.querySelectorAll('[data-src*="localhost"]').forEach(el => {
        try {
          const url = new URL(el.dataset.src);
          el.dataset.src = url.pathname;
        } catch (e) {
          console.error('Error fixing data-src:', e);
        }
      });

      // Fix all background images with localhost
      document.querySelectorAll('[style*="localhost"]').forEach(el => {
        try {
          let style = el.getAttribute('style');
          if (style) {
            style = style.replace(/url\(['"]?http:\/\/localhost:[0-9]+([^'"]+)['"]?\)/g, "url('$1')");
            el.setAttribute('style', style);
          }
        } catch (e) {
          console.error('Error fixing background image:', e);
        }
      });

      // Fix all links with localhost
      document.querySelectorAll('a[href*="localhost"]').forEach(a => {
        try {
          const url = new URL(a.href);
          a.href = url.pathname;
        } catch (e) {
          console.error('Error fixing link:', e);
        }
      });
      
      return true; // Indicate changes were made
    }
    
    return false; // No changes needed
  }

  // Fix HTTP to HTTPS for Google Fonts
  const fixGoogleFonts = function() {
    document.querySelectorAll('link[href*="fonts.googleapis.com"]').forEach(function(link) {
      if (link.href.startsWith('http://')) {
        link.href = link.href.replace('http://', 'https://');
      }
    });
  };

  // Fix localhost URLs in src attributes
  const fixLocalhost = function() {
    document.querySelectorAll('[src*="localhost"]').forEach(function(el) {
      try {
        const url = new URL(el.src);
        el.src = url.pathname;
      } catch (e) {
        console.error('Error fixing localhost URL:', e);
      }
    });
  };

  // Fix background images with localhost
  const fixBackgroundImages = function() {
    document.querySelectorAll('[style*="localhost"]').forEach(function(el) {
      try {
        let style = el.getAttribute('style');
        if (style) {
          style = style.replace(/url\(['"]?http:\/\/localhost:[0-9]+([^'"]+)['"]?\)/g, "url('$1')");
          el.setAttribute('style', style);
        }
      } catch (e) {
        console.error('Error fixing background image:', e);
      }
    });
  };

  // Fix data-src attributes for lazy loading
  const fixDataSrc = function() {
    document.querySelectorAll('[data-src*="localhost"]').forEach(function(el) {
      try {
        const url = new URL(el.dataset.src);
        el.dataset.src = url.pathname;
      } catch (e) {
        console.error('Error fixing data-src:', e);
      }
    });
  };

  // Fix all link elements with localhost
  const fixLinks = function() {
    document.querySelectorAll('a[href*="localhost"]').forEach(function(el) {
      try {
        const url = new URL(el.href);
        el.href = url.pathname;
      } catch (e) {
        console.error('Error fixing link:', e);
      }
    });
  };

  // Fix favicon link
  const fixFavicon = function() {
    document.querySelectorAll('link[rel="icon"]').forEach(function(link) {
      if (link.href && link.href.includes('localhost')) {
        const url = new URL(link.href);
        link.href = url.pathname;
      }
    });
  };

  // Run all fixes
  const runFixes = function() {
    // Increment fixes counter and check if we've already done enough fixes
    fixesApplied++;
    if (fixesApplied > MAX_FIXES) {
      console.log(`URL fixes already applied ${fixesApplied} times. Marking as complete.`);
      window.__urlFixesApplied = true;
      return;
    }
    
    console.log(`Running URL fixes from fixurls.js (attempt ${fixesApplied}/${MAX_FIXES})...`);
    fixGoogleFonts();
    fixLocalhost();
    fixBackgroundImages();
    fixDataSrc();
    fixLinks();
    fixFavicon();
    
    // Final check for any remaining localhost issues
    if (hasLocalhostReferences()) {
      console.log('Still found localhost references, trying targeted element fixes...');
      fixHtmlContent();
    }
    
    // Check if all fixes were successful
    checkAndMarkComplete();
  };

  // Run immediately on script load
  runFixes();

  // Also run when DOM is fully loaded, but only if needed
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      // Only run if we haven't applied fixes yet and there are still localhost URLs
      if (fixesApplied <= MAX_FIXES && hasLocalhostReferences()) {
        runFixes();
      } else {
        checkAndMarkComplete();
      }
    });
  }

  // Signal completion to main.js
  window.__urlFixesRunning = false;
})(); 